import { Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Footer.css";
import footerImage from "../../assets/images/footer.png";
import footerImage2 from "../../assets/images/footer2.png";

export const Footer = (props) => {
  return (
    <Col sm={12} lg={12} className="footer-main ">
      <img
        src={footerImage}
        alt="footer-cc"
        className="w-100 footer-cc-img "
        style={{ marginTop: "-1px" }}
      />
      <img src={footerImage2} alt="footer-cc" className="w-100 footer-cc-img" />

      <Col sm={12} lg={12} className="footer">
        <div className="footer-links ">
          <Link to="/privacy-policy" className="footer-link">
            Privacy Policy
          </Link>
          {" | "}
          <Link to="/terms" className="footer-link">
            Terms & Conditions
          </Link>
          {" | "}
          <Link to="/cookie-policy" className="footer-link">
            Cookie Policy
          </Link>
        </div>
        <div className="footer-copyright">
          <p className="copyright-text">
            © 2025 The Coca-Cola Company. All rights reserved.
          </p>
        </div>
      </Col>
    </Col>
  );
};
